import React,{useState,useEffect,useRef,useMemo,useCallback} from 'react';
import {motion,AnimatePresence} from 'framer-motion';
import {FiX,FiPlay,FiCheck,FiClock,FiStar,FiPhone,FiMail,FiUser,FiBriefcase,FiChevronDown,FiSearch,FiFilter} from 'react-icons/fi';
import './App.css';
import HeroSection from './components/HeroSection';
import WorkshopTimer from './components/WorkshopTimer';
import {useWorkshopSchedule} from './hooks/useWorkshopSchedule';

const PAYMENT_BASE_URL="https://paymentz.aifunnels.app/product/21362/page/21968/addon-page?staffId=65130&ac=1";
// Updated webhook URL
const WEBHOOK_URL="https://connect.pabbly.com/workflow/sendwebhookdata/IjU3NjYwNTY0MDYzMDA0MzQ1MjY5NTUzMTUxMzAi_pc";

// --- NEW: Animation Variants for smooth,staggered loading ---
// Parent container variant: Manages the 'staggerChildren' effect
const containerVariants={
  hidden: {opacity: 0},
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,// Each child will animate 0.1s after the previous one
      ease: "easeInOut"
    },
  },
};

// Child item variant: The animation each individual item will perform
const itemVariants={
  hidden: {opacity: 0,y: 20},
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring',// Use a spring for a bouncier,smoother feel
      stiffness: 100,
      damping: 12
    }
  },
};

// Section fade-in variant
const sectionFadeIn={
  initial: {opacity: 0,y: 30},
  whileInView: {opacity: 1,y: 0},
  transition: {duration: 0.7,ease: "easeInOut"},
  viewport: {once: true,amount: 0.2} // Trigger animation when 20% visible
};

// --- End of New Variants ---

// Video testimonials data
const testimonialVideos=[
  {
    id: 1,
    url: "https://www.youtube.com/watch?v=v3EEtDIaC3w",
    embedId: "v3EEtDIaC3w",
    thumbnail: "https://img.youtube.com/vi/v3EEtDIaC3w/maxresdefault.jpg",
    title: "How Funnels Done Transformed My Coaching Business",
    name: "A Woman Entrepreneur Coach"
  },
  {
    id: 2,
    url: "https://youtu.be/IrfPwkcSTB0?si=4zR7J5O2aIbdr7k0",
    embedId: "IrfPwkcSTB0",
    thumbnail: "https://img.youtube.com/vi/IrfPwkcSTB0/maxresdefault.jpg",
    title: "From Struggling to 2 Lakhs: My Funnels Done Success Story",
    name: "Bridal Lead Generation Expert Coach"
  },
  {
    id: 3,
    url: "https://youtu.be/F26JiMS-w4I?si=5CoJ4w0AnUAMPYZm",
    embedId: "F26JiMS-w4I",
    thumbnail: "https://img.youtube.com/vi/F26JiMS-w4I/maxresdefault.jpg",
    title: "Overcoming Coaching Business Challenges with Funnels Done",
    name: "Coaching Business"
  },
  {
    id: 4,
    url: "https://youtu.be/yWzJt7jv5CM?si=cFmZMEoNQgvFxmh4",
    embedId: "yWzJt7jv5CM",
    thumbnail: "https://img.youtube.com/vi/yWzJt7jv5CM/maxresdefault.jpg",
    title: "How I Made 30 Lakhs in a Year by Helping a Lot of People as a Coach without Quiting my Job",
    name: "Professor"
  },
  {
    id: 5,
    url: "https://youtu.be/vRzrNK9XPmQ?si=HcsiRvsrjOQhzfiO",
    embedId: "vRzrNK9XPmQ",
    thumbnail: "https://img.youtube.com/vi/vRzrNK9XPmQ/maxresdefault.jpg",
    title: "How Dr. Valarmathi Automated Leads & Sales With FunnelsDone",
    name: "Doctor"
  },
  {
    id: 6,
    url: "https://youtube.com/shorts/L0jJ2NHIQ8w?si=vDvB1EIcSDn0lzHX",
    embedId: "L0jJ2NHIQ8w",
    thumbnail: "https://img.youtube.com/vi/L0jJ2NHIQ8w/maxresdefault.jpg",
    title: "The Secret Behind Mariyappan's Business Growth 🔥 | FunnelsDone AI",
    name: "Iniya Jewelers Madurai"
  }
];

// Client Feedback data with images
const clientFeedbacks=[
  {
    id: 1,
    name: "A R Ahamed Junaith",
    role: "Spoken English Coach",
    image: "https://storage.files-vault.com/uploads/1760941910-ht57JBdJ4f.webp",
    quote: "21+ Lakhs Revenue in Just 10 Months — While Still Working as College Professor"
  },
  {
    id: 2,
    name: "Maria Sundar",
    role: "Stock Trader Coach",
    image: "https://storage.files-vault.com/uploads/1760942061-nsFEgCbsBd.webp",
    quote: "1,000+ Paid Members & 3.8 Lakhs Collected in Just 60 Days with Trading Webinars"
  },
  {
    id: 3,
    name: "Arjumand",
    role: "Community Growth Expert",
    image: "https://storage.files-vault.com/uploads/1760942064-I6HBtoRq5t.webp",
    quote: "60 Organic Registrations,30 Showups,Multiple Sales in 1 Week — Zero Ads!"
  },
  {
    id: 4,
    name: "Subiya Fathima",
    role: "Bridal Leads Coach",
    image: "https://storage.files-vault.com/uploads/1760942062-cWbhjZc7n9.webp",
    quote: "Sold 5,999 Course to 19 Clients in One Day — Cleared Son's School Fee Same Week"
  },
  {
    id: 5,
    name: "Manigandan",
    role: "FiveStar",
    image: "https://storage.files-vault.com/uploads/1760942066-tiqyCho8Gf.webp",
    quote: "Tamil Solopreneurs Crossed 1 Crore in a Week,10 Lakhs in a Month & More — Using AI Smart Funnels"
  },
  {
    id: 6,
    name: "Bindhu Madhavan",
    role: "Prompt Committee",
    image: null,
    quote: "I started with zero audience and no marketing budget. In just 60 days,I built a ₹3.8 Lakh income system with over 1,000 paid members"
  }
];

// FAQ data with exact copy - Updated for Thursday schedule
const faqData=[
  {
    id: 1,
    question: "When and where is this workshop happening?",
    answer: "This is a 3-hour LIVE online workshop happening this Sunday from 4:00 PM - 7:00 PM IST. Once you register,you'll get the joining link by email and WhatsApp."
  },
  {
    id: 2,
    question: "Is this session live or pre-recorded?",
    answer: "It's 100% LIVE — Abdul Hakkim himself will teach,explain step-by-step,and answer your questions in real time."
  },
  {
    id: 3,
    question: "Do I need any technical knowledge or special tools?",
    answer: "No. This workshop is designed for complete beginners — no coding or advanced tech skills needed. Everything is explained in simple terms."
  },
  {
    id: 4,
    question: "Will I get recordings if I can't attend live?",
    answer: "No Recording will be provided,It's Live only Workshop"
  },
  {
    id: 5,
    question: "How do I know this will actually help me?",
    answer: "It's made for complete beginners — with step-by-step help,free tools,and support,so you'll never feel lost."
  },
  {
    id: 6,
    question: "What happens after I register?",
    answer: "You'll immediately receive a confirmation email and WhatsApp message with your unique joining link,your bonus details,and instructions. You'll also get reminders so you don't miss it. OR You Can Email us at support@yinguru.com"
  },
  {
    id: 7,
    question: "What if I have more questions or get stuck later?",
    answer: "You'll get Lifetime Access to the IncomeDone Community — with courses,templates,and live support so you're never alone."
  },
  {
    id: 8,
    question: "Still have a doubt?",
    answer: "Just WhatsApp us anytime — our team is ready to help you get started with confidence. Email: support@yinguru.com WhatsApp Support."
  }
];

// Country codes for phone input
const countryCodes=[
  {code: "+91",country: "IN",flag: "🇮🇳"},
  {code: "+1",country: "US",flag: "🇺🇸"},
  {code: "+44",country: "UK",flag: "🇬🇧"},
  {code: "+65",country: "SG",flag: "🇸🇬"},
  {code: "+971",country: "AE",flag: "🇦🇪"}
];

// Enhanced tracking data extraction function
const getTrackingData = () => {
  const urlParams = new URLSearchParams(window.location.search);
  
  return {
    // Meta Ads tracking parameters
    campaign_id: urlParams.get('campaign_id') || '',
    adset_id: urlParams.get('adset_id') || '',
    ad_id: urlParams.get('ad_id') || '',
    fbclid: urlParams.get('fbclid') || '',
    
    // Google Ads tracking
    gclid: urlParams.get('gclid') || '',
    
    // UTM parameters
    utm_source: urlParams.get('utm_source') || '',
    utm_medium: urlParams.get('utm_medium') || '',
    utm_campaign: urlParams.get('utm_campaign') || '',
    utm_term: urlParams.get('utm_term') || '',
    utm_content: urlParams.get('utm_content') || '',
    
    // Additional tracking
    source: urlParams.get('source') || 'organic',
    medium: urlParams.get('medium') || '',
    
    // Referrer information
    referrer: document.referrer || '',
    
    // Page information
    page_url: window.location.href,
    page_title: document.title,
    
    // Timestamp
    timestamp: new Date().toISOString(),
    
    // Session information
    user_agent: navigator.userAgent,
    session_id: sessionStorage.getItem('session_id') || Date.now().toString()
  };
};

// Generate workshop batch ID based on date
const generateWorkshopBatchId = (workshopDate) => {
  if (!workshopDate) return 'BATCH_UNKNOWN';
  
  const date = new Date(workshopDate);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  
  return `BATCH_${year}${month}${day}`;
};

function App() {
  const [isFormModalOpen,setIsFormModalOpen]=useState(false);
  const [selectedVideo,setSelectedVideo]=useState(null);
  const [formData,setFormData]=useState({
    name: '',
    email: '',
    countryCode: '+91',
    phone: '',
    profession: '',
    consent: false
  });
  const [formErrors,setFormErrors]=useState({});
  const [isSubmitting,setIsSubmitting]=useState(false);
  const [showSuccess,setShowSuccess]=useState(false);
  const [expandedFaq,setExpandedFaq]=useState(null);
  const [faqSearch,setFaqSearch]=useState('');
  const [searchTimeout,setSearchTimeout]=useState(null);
  const [selectedRoleFilter,setSelectedRoleFilter]=useState('all');
  const [expandedFeedback,setExpandedFeedback]=useState({});
  const [hasAutoPopupShown,setHasAutoPopupShown]=useState(false);
  const modalRef=useRef(null);
  const firstInputRef=useRef(null);
  const autoPopupTimeoutRef=useRef(null);

  // Use workshop schedule hook
  const {workshopDetails,countdownTarget}=useWorkshopSchedule();

  // Initialize session tracking
  useEffect(() => {
    if (!sessionStorage.getItem('session_id')) {
      sessionStorage.setItem('session_id', Date.now().toString());
    }
  }, []);

  // Auto-popup registration modal after 10 seconds
  useEffect(()=> {
    // Only show auto-popup once per session and if modal isn't already open
    if (!hasAutoPopupShown && !isFormModalOpen) {
      autoPopupTimeoutRef.current=setTimeout(()=> {
        setIsFormModalOpen(true);
        setHasAutoPopupShown(true);
        
        // Track auto-popup event with Facebook Pixel
        if (typeof fbq !=='undefined') {
          fbq('track','ViewContent',{
            content_name: 'Sales Automation Workshop - Auto Popup',
            content_category: 'Workshop',
            content_type: 'auto_popup',
            value: 9,
            currency: 'INR'
          });
        }
      },10000);// 10 seconds
    }
    
    // Cleanup function to prevent memory leaks
    return ()=> {
      if (autoPopupTimeoutRef.current) {
        clearTimeout(autoPopupTimeoutRef.current);
        autoPopupTimeoutRef.current=null;
      }
    };
  },[hasAutoPopupShown,isFormModalOpen]);

  // Modal focus management and keyboard handling
  useEffect(()=> {
    if (isFormModalOpen && firstInputRef.current) {
      firstInputRef.current.focus();
    }
    
    const handleKeyDown=(e)=> {
      if (e.key==='Escape') {
        setIsFormModalOpen(false);
        setSelectedVideo(null);
      }
    };

    if (isFormModalOpen || selectedVideo) {
      document.addEventListener('keydown',handleKeyDown);
      document.body.style.overflow='hidden';
    } else {
      document.body.style.overflow='unset';
    }
    
    return ()=> {
      document.removeEventListener('keydown',handleKeyDown);
      document.body.style.overflow='unset';
    };
  },[isFormModalOpen,selectedVideo]);

  // Debounced FAQ search
  const handleFaqSearch=useCallback((value)=> {
    setFaqSearch(value);
    if (searchTimeout) clearTimeout(searchTimeout);
    const newTimeout=setTimeout(()=> {},300);
    setSearchTimeout(newTimeout);
  },[searchTimeout]);

  const filteredFaqs=useMemo(()=> {
    if (!faqSearch.trim()) return faqData;
    return faqData.filter(
      faq=> 
        faq.question.toLowerCase().includes(faqSearch.toLowerCase()) || 
        faq.answer.toLowerCase().includes(faqSearch.toLowerCase())
    );
  },[faqSearch]);

  const filteredFeedbacks=useMemo(()=> {
    if (selectedRoleFilter==='all') return clientFeedbacks;
    return clientFeedbacks.filter(feedback=> 
      feedback.role.toLowerCase().includes(selectedRoleFilter.toLowerCase())
    );
  },[selectedRoleFilter]);

  const uniqueRoles=useMemo(()=> 
    ['all',...new Set(clientFeedbacks.map(f=> f.role))],
    []
  );

  const toggleFaq=(faqId)=> setExpandedFaq(expandedFaq===faqId ? null : faqId);

  const toggleFeedbackExpanded=(feedbackId)=> 
    setExpandedFeedback(prev=> ({...prev,[feedbackId]: !prev[feedbackId]}));

  const validateForm=()=> {
    const errors={};
    if (!formData.name.trim()) errors.name='Name is required';
    if (!formData.email.trim()) errors.email='Email is required';
    else if (!/\S+@\S+\.\S+/.test(formData.email)) errors.email='Please enter a valid email';
    if (!formData.phone.trim()) errors.phone='Phone number is required';
    else if (!/^\d{10}$/.test(formData.phone.replace(/\s/g,''))) errors.phone='Please enter a valid 10-digit phone number';
    if (!formData.profession.trim()) errors.profession='Profession/Role is required';
    if (!formData.consent) errors.consent='Please agree to the terms';
    
    setFormErrors(errors);
    return Object.keys(errors).length===0;
  };

  const handleSubmit=async (e)=> {
    e.preventDefault();
    if (!validateForm() || isSubmitting) return;

    setIsSubmitting(true);
    
    try {
      const phoneWithCountryCode=`${formData.countryCode}${formData.phone}`;
      
      // Get enhanced tracking data
      const trackingData = getTrackingData();
      
      // Generate workshop batch information
      const workshopBatchId = generateWorkshopBatchId(workshopDetails.date);
      const workshopBatchInfo = {
        batch_id: workshopBatchId,
        batch_date: workshopDetails.formattedDate,
        batch_time: workshopDetails.timeString,
        batch_day: workshopDetails.dayOfWeek || 'Sunday',
        batch_duration: workshopDetails.duration || '3 hours',
        batch_timezone: workshopDetails.timezone || 'IST',
        batch_status: workshopDetails.status || 'upcoming'
      };

      // Prepare webhook payload with enhanced tracking and batch info
      const webhookPayload={
        // Form data
        name: formData.name,
        email: formData.email,
        phone: phoneWithCountryCode,
        profession: formData.profession,
        
        // Workshop batch details
        ...workshopBatchInfo,
        
        // Legacy workshop details (for backward compatibility)
        workshop_date: workshopDetails.formattedDate,
        workshop_time: workshopDetails.timeString,
        
        // Enhanced tracking data
        ...trackingData,
        
        // Additional metadata
        form_submission_source: 'landing_page',
        conversion_type: 'registration',
        product_name: 'Sales Automation Workshop',
        product_price: 9,
        currency: 'INR',
        
        // Registration metadata
        registration_timestamp: new Date().toISOString(),
        registration_source: 'website_form'
      };

      // Send to webhook
      try {
        const webhookResponse = await fetch(WEBHOOK_URL,{
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(webhookPayload)
        });
        
        if (!webhookResponse.ok) {
          console.warn('Webhook response not OK:', webhookResponse.status);
        }
        
        console.log('Webhook data sent successfully:', webhookPayload);
      } catch (webhookError) {
        console.warn('Webhook submission failed:',webhookError);
        // Continue with payment even if webhook fails
      }

      // Track Facebook Pixel conversion
      if (typeof fbq !=='undefined') {
        fbq('track','Lead',{
          content_name: 'Sales Automation Workshop Registration',
          content_category: 'Workshop',
          value: 9,
          currency: 'INR',
          // Include meta ads parameters for better attribution
          ...(trackingData.campaign_id && { campaign_id: trackingData.campaign_id }),
          ...(trackingData.adset_id && { adset_id: trackingData.adset_id }),
          ...(trackingData.ad_id && { ad_id: trackingData.ad_id }),
          // Include batch information
          custom_batch_id: workshopBatchId
        });
      }

      // Build payment URL with enhanced tracking parameters and batch info
      const paymentParams=new URLSearchParams();
      
      // Standard form fields
      paymentParams.append('first_name',formData.name.trim());
      paymentParams.append('email',formData.email.trim());
      paymentParams.append('phone_no',phoneWithCountryCode);
      paymentParams.append('customer_profession',formData.profession);
      
      // Alternative parameter names (in case the gateway expects different names)
      paymentParams.append('name',formData.name.trim());
      paymentParams.append('phone',phoneWithCountryCode);
      paymentParams.append('profession',formData.profession);
      
      // Additional common parameter variations
      paymentParams.append('full_name',formData.name.trim());
      paymentParams.append('user_name',formData.name.trim());
      paymentParams.append('contact_name',formData.name.trim());
      paymentParams.append('billing_name',formData.name.trim());
      paymentParams.append('email_address',formData.email.trim());
      paymentParams.append('user_email',formData.email.trim());
      paymentParams.append('contact_email',formData.email.trim());
      paymentParams.append('billing_email',formData.email.trim());
      paymentParams.append('phone_number',phoneWithCountryCode);
      paymentParams.append('mobile',phoneWithCountryCode);
      paymentParams.append('mobile_number',phoneWithCountryCode);
      paymentParams.append('contact_phone',phoneWithCountryCode);
      paymentParams.append('billing_phone',phoneWithCountryCode);

      // Add workshop batch information to payment URL
      Object.entries(workshopBatchInfo).forEach(([key,value])=> {
        if (value && value.toString().trim()) {
          paymentParams.append(key,value.toString().trim());
        }
      });
      
      // Add workshop information with different parameter names for compatibility
      paymentParams.append('workshop_batch',workshopBatchId);
      paymentParams.append('workshop_date',workshopDetails.formattedDate);
      paymentParams.append('workshop_time',workshopDetails.timeString);
      paymentParams.append('event_date',workshopDetails.formattedDate);
      paymentParams.append('event_time',workshopDetails.timeString);
      paymentParams.append('event_batch',workshopBatchId);
      paymentParams.append('course_batch',workshopBatchId);
      paymentParams.append('batch',workshopBatchId);

      // Add ALL tracking parameters to payment URL
      Object.entries(trackingData).forEach(([key,value])=> {
        if (value && value.toString().trim()) {
          paymentParams.append(key,value.toString().trim());
        }
      });

      // Construct the final payment URL
      const paymentUrl=`${PAYMENT_BASE_URL}&${paymentParams.toString()}`;

      // Debug log to check the URL structure
      console.log('Payment URL:',paymentUrl);
      console.log('Form Data being sent:',{
        name: formData.name,
        email: formData.email,
        phone: phoneWithCountryCode,
        profession: formData.profession
      });
      console.log('Workshop Batch Info:',workshopBatchInfo);
      console.log('Tracking Data being sent:',trackingData);

      // Open payment page
      window.open(paymentUrl,'_blank');
      
      setShowSuccess(true);
      setIsFormModalOpen(false);
      setFormData({
        name: '',
        email: '',
        countryCode: '+91',
        phone: '',
        profession: '',
        consent: false
      });
      
      setTimeout(()=> setShowSuccess(false),5000);

    } catch (error) {
      console.error('Form submission error:',error);
      alert('There was an error submitting the form. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleInputChange=(field,value)=> {
    setFormData(prev=> ({...prev,[field]: value}));
    if (formErrors[field]) setFormErrors(prev=> ({...prev,[field]: ''}));
  };

  const getInitials=(name)=> 
    name.split(' ').map(word=> word[0]).join('').toUpperCase().slice(0,2);

  // Handle manual modal open (clear auto-popup timer if it exists)
  const handleManualModalOpen=()=> {
    if (autoPopupTimeoutRef.current) {
      clearTimeout(autoPopupTimeoutRef.current);
      autoPopupTimeoutRef.current=null;
    }
    setHasAutoPopupShown(true);// Prevent auto-popup from showing later
    setIsFormModalOpen(true);
  };

  return (
    <>
      {/* --- NEW: Poppins Font Import and Styles --- */}
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap');
          .app,.modal-content {
            font-family: 'Poppins',sans-serif;
          }
          .section-content h2,.mentor-info h2,.final-cta h2 {
            font-weight: 700;/* Bolder headings */
          }
          /* --- Sticky Footer Styles --- */
          .sticky-footer {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 12px 20px;
            /* --- MODIFIED: Restored contrast gradient --- */
            background: linear-gradient(90deg,#0b1324,#101c33);
            color: white;
            z-index: 40;/* Below modals (z-50) but above content */
            box-shadow: 0 -4px 12px rgba(0,0,0,0.1);
          }
          .footer-info-box {
            background: rgba(255,255,255,0.1);
            border-radius: 12px;
            padding: 10px 16px;
            font-size: 0.9rem;
            font-weight: 600;
            text-align: left;
            line-height: 1.4;
          }
          .footer-info-box .date {
            color: #f3f4f6;/* Lighter text */
          }
          .footer-info-box .time {
            color: #fb923c;/* Orange color */
          }
          .footer-cta-button {
            background: #fb923c;/* Bright orange CTA */
            color: #1f2937;/* Dark text */
            font-weight: 700;
            padding: 12px 20px;
            border-radius: 12px;
            border: none;
            cursor: pointer;
            font-size: 1rem;
            box-shadow: 0 4px 10px rgba(251,146,60,0.3);
          }
          .app {
            padding-bottom: 0;
          }
          /* Hide footer on mobile */
          @media (max-width: 640px) {
            .sticky-footer {
              display: none;
            }
          }
          /* Only add padding on desktop */
          @media (min-width: 641px) {
            .app {
              padding-bottom: 90px;/* Shorter footer on desktop */
            }
          }
        `}
      </style>

      <div className="app">
        <AnimatePresence>
          {showSuccess && (
            <motion.div
              className="success-toast"
              initial={{opacity: 0,y: -50}}
              animate={{opacity: 1,y: 0}}
              exit={{opacity: 0,y: -50}}
              transition={{type: "spring",stiffness: 300,damping: 20}}
            >
              <FiCheck className="success-icon" />
              Registration successful! Payment page opened in new tab.
            </motion.div>
          )}
        </AnimatePresence>

        <HeroSection openRegistration={handleManualModalOpen} />

        {/* --- Section 2: Problem & Agitation --- */}
        <motion.section
          className="problem-section"
          initial="initial"
          whileInView="whileInView"
          transition={sectionFadeIn.transition}
          viewport={sectionFadeIn.viewport}
        >
          <div className="container">
            <motion.div className="section-content">
              <motion.h2 {...sectionFadeIn}>
                😰 "Leads-க்கா? Follow-up-க்கா?" Time Waste பண்ணாதீங்க!
              </motion.h2>
              
              <motion.div 
                className="problem-intro" 
                {...sectionFadeIn} 
                transition={{delay: 0.1,...sectionFadeIn.transition}}
              >
                <p>Successful Business Owners-ஐ பாக்கறீங்க... அவங்க growth-ல் மட்டும் focus பண்றாங்க. ஆனா நீங்க leads,enquiries,payment follow-ups-லேயே stuck-ஆகி இருக்கீங்க. You're not alone.</p>
              </motion.div>

              <motion.div
                className="problem-grid"
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{once: true,amount: 0.2}}
              >
                {[
                  {
                    emoji: "💸",
                    title: "Enquiries-ல் Price மட்டும் கேட்டுட்டு போறாங்களா?",
                    desc: "Client-ஐ DM-ல் close பண்ண முடியலையா? Enquiries வருது... ஆனா sales-ஆக convert ஆகலையா? Likes வருது,leads வரல."
                  },
                  {
                    emoji: "😵‍💫",
                    title: "Lead Forms-ம் Follow-ups-ம் Manage பண்ணவே நேரமில்லையா?",
                    desc: "Sheets,DMs,WhatsApp,Calls... எல்லாத்தையும் நீங்களே தனியா manage பண்ணி 'overwhelmed'-ஆ இருக்கீங்களா? Tech-னாலே stress-ஆ இருக்கா?"
                  },
                  {
                    emoji: "📚",
                    title: "Product-ல் நீங்க Pro... ஆனா Sales Process-ல் Zero-வா?",
                    desc: "நீங்க business-ஐ கத்துக்கிட்டீங்க. ஆனா leads,payments,follow-ups-ஐ handle பண்ண கத்துக்கல. இதுனால business grow ஆகல."
                  },
                  {
                    emoji: "😩",
                    title: "2 Weeks-ஆ Payment-க்கு Follow-up பண்ணி Tired-ஆ?",
                    desc: "Sales close பண்ண 2 hours... ஆனா payment வாங்க 2 weeks! Client-கிட்ட திரும்ப திரும்ப payment கேட்டு 'figure-it-out' பண்ணி alone-ஆ feel பண்றீங்களா?"
                  }
                ].map((problem)=> (
                  <motion.div
                    key={problem.title}
                    className="problem-card"
                    variants={itemVariants}
                    whileHover={{y: -8,transition: {duration: 0.2}}}
                  >
                    <h3>{problem.emoji} {problem.title}</h3>
                    <p>{problem.desc}</p>
                  </motion.div>
                ))}
              </motion.div>
            </motion.div>
          </div>
        </motion.section>

        {/* --- Section 3: The Solution --- */}
        <motion.section
          className="solution-section"
          initial="initial"
          whileInView="whileInView"
          transition={sectionFadeIn.transition}
          viewport={sectionFadeIn.viewport}
        >
          <div className="container">
            <motion.div className="section-content">
              <motion.h2 {...sectionFadeIn}>
                🎯 உண்மை இதுதான்: Business-க்கு Foundation போல... Sales-க்கு AI Automation!
              </motion.h2>
              
              <motion.div 
                className="solution-intro" 
                {...sectionFadeIn} 
                transition={{delay: 0.1,...sectionFadeIn.transition}}
              >
                <p>Product sell பண்றதுல நீங்க Expert... ஆனா business admin (leads,payments) ஒரு "headache"-ஆ இருக்கு. What you need is a <strong>simple AI automation system</strong>.</p>
                <p>It doesn't have to be this hard. இந்த 3-Hour Workshop-ல்,உங்க sales process-ஐ autopilot-ல் run பண்ண கத்துக்கலாம்.</p>
              </motion.div>

              <div className="comparison-table">
                <motion.div 
                  className="old-way" 
                  {...sectionFadeIn} 
                  transition={{delay: 0.2,...sectionFadeIn.transition}}
                >
                  <h3>❌ நீங்க இப்ப பண்றது (The Old Way)</h3>
                  <ul>
                    <li>Enquiries-க்கு நீங்களே reply பண்றது</li>
                    <li>Leads-ஐ manually check பண்றது</li>
                    <li>Payment-க்கு நீங்களே call / follow-up பண்றது</li>
                    <li>Admin work-லேயே time waste பண்றது</li>
                    <li>Business-ஐ grow பண்ண time இல்லாம போறது</li>
                    <li>Tech-ஐ பாத்து stress ஆகுறது</li>
                  </ul>
                </motion.div>

                <motion.div 
                  className="new-way" 
                  {...sectionFadeIn} 
                  transition={{delay: 0.4,...sectionFadeIn.transition}}
                >
                  <h3>✅ இந்த LIVE Session-ல் கத்துக்க போறது (The AI Way)</h3>
                  <ul>
                    <li>AI Agent 24/7 Enquiries-ஐ Handle பண்ணும்</li>
                    <li>AI உங்க leads-ஐ auto-qualify பண்ணும்</li>
                    <li>AI payment-க்கு follow-up & call கூட பண்ணும்</li>
                    <li>90% Admin Work AUTOPILOT-ல்! 🚀</li>
                    <li>உங்க Growth-ல் மட்டும் focus பண்ணலாம்</li>
                    <li>Clarity-யோட business-ஐ 10x grow பண்ணலாம்</li>
                  </ul>
                </motion.div>
              </div>
            </motion.div>
          </div>
        </motion.section>

        {/* --- Section 4: What You Will Discover --- */}
        <motion.section
          className="discovery-section"
          initial="initial"
          whileInView="whileInView"
          transition={sectionFadeIn.transition}
          viewport={sectionFadeIn.viewport}
        >
          <div className="container">
            <motion.div className="section-content">
              <motion.h2 {...sectionFadeIn}>
                🚀 இந்த LIVE Workshop-ல் என்ன கத்துப்பீங்க?
              </motion.h2>
              
              <motion.div 
                className="discovery-intro" 
                {...sectionFadeIn} 
                transition={{delay: 0.1,...sectionFadeIn.transition}}
              >
                <p>This isn't another generic webinar. இது உங்க Sales process-ஐ automate பண்றதுக்கான exact blueprint.</p>
              </motion.div>

              <motion.div
                className="discovery-grid"
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{once: true,amount: 0.2}}
              >
                {[
                  {
                    icon: "🤖",
                    title: "24/7 AI Lead Agent",
                    desc: "Client Enquiries-க்கு automatic-ஆக reply பண்ற... (price,details சொல்ற) ஒரு AI Agent-ஐ எப்படி build பண்றது."
                  },
                  {
                    icon: "📅",
                    title: "Auto-Followup Bot",
                    desc: "உங்க AI-ஐ CRM/Sheet கூட link பண்ணி,leads-ஐ automatic-ஆக follow-up பண்ற secret."
                  },
                  {
                    icon: "💰",
                    title: "The 'AI Payment Bot'",
                    desc: "Payment-க்காக follow-up பண்ணி,invoice அனுப்பி,confirm பண்ண *call கூட பேசும்* ஒரு AI-ஐ எப்படி create பண்றது."
                  },
                  {
                    icon: "🤝",
                    title: "90% Admin Work Automation",
                    desc: "இந்த 3 systems-ஐயும் ஒண்ணா connect பண்ணி,உங்க 90% வேலையை AI பாத்துக்கற full system."
                  },
                  {
                    icon: "⚡",
                    title: "No Tech Stress,Just Growth!",
                    desc: "Coding,tech stress இல்லாம... உங்க Business Growth-ல் மட்டும் focus பண்ணுங்க. Sales-ஐ AI பாத்துக்கும்."
                  }
                ].map((item)=> (
                  <motion.div
                    key={item.title}
                    className="discovery-item"
                    variants={itemVariants}
                    whileHover={{y: -8,scale: 1.02}}
                  >
                    <div className="discovery-icon">{item.icon}</div>
                    <h3>{item.title}</h3>
                    <p>{item.desc}</p>
                  </motion.div>
                ))}
              </motion.div>
            </motion.div>
          </div>
        </motion.section>

        {/* --- Section 5: Meet Your Mentor --- */}
        <section className="mentor-section py-16 bg-[#0b1324] text-gray-200">
          <div className="container mx-auto px-4">
            <motion.div
              className="mentor-content grid items-center gap-10 lg:grid-cols-2"
              initial="initial"
              whileInView="whileInView"
              transition={sectionFadeIn.transition}
              viewport={sectionFadeIn.viewport}
            >
              <div className="flex justify-center lg:justify-end">
                <motion.div
                  className="rounded-3xl border-2 border-orange-400 p-3 shadow-lg shadow-orange-500/20 bg-[#101c33]"
                  whileHover={{scale: 1.02}}
                  transition={{duration: 0.3}}
                >
                  <img
                    src="https://storage.files-vault.com/uploads/1761032692-VSdwsp8AG0.png"
                    alt="Abdul Hakkim - AI Business Mentor - 10xAI Tamil Founder Program"
                    loading="lazy"
                    className="rounded-2xl w-full max-w-[360px] md:max-w-[400px] object-cover"
                  />
                </motion.div>
              </div>

              <div className="mentor-info max-w-xl mx-auto lg:mx-0">
                <motion.h2
                  className="text-3xl md:text-4xl font-bold text-orange-400 mb-6 flex items-center gap-2"
                  {...sectionFadeIn}
                >
                  🎯 <span>Meet Abdul Hakkim</span>
                </motion.h2>

                <motion.p
                  className="text-base md:text-lg leading-relaxed mb-6 text-gray-300"
                  {...sectionFadeIn}
                  transition={{delay: 0.1,...sectionFadeIn.transition}}
                >
                  I know exactly how you feel. நான் நிறைய Business Owners/Coaches-ஐ பாத்துருக்கேன்... அவங்க product/service சூப்பரா இருக்கும்,ஆனா DMs,leads,payment follow-ups-லேயே அவங்க time-ம் energy-ம் waste ஆகுது. The truth is — you're meant for more.
                </motion.p>

                <motion.ul
                  className="space-y-4 text-gray-300 text-base md:text-lg"
                  variants={containerVariants}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{once: true,amount: 0.2}}
                >
                  {[
                    {
                      emoji: "🎯",
                      color: "text-yellow-400",
                      title: "The Real Problem:",
                      desc: "Business-ல் நீங்க expert... ஆனா sales admin (leads,payments) ஒரு பெரிய 'headache'-ஆ இருக்கு."
                    },
                    {
                      emoji: "✅",
                      color: "text-green-400",
                      title: "My Promise:",
                      desc: "A simple AI system with real mentorship. உங்க admin headache-ஐ AI-கிட்ட குடுத்துட்டு,நீங்க growth-ல் focus பண்ணலாம்."
                    },
                    {
                      emoji: "📈",
                      color: "text-blue-400",
                      title: "Proven Results:",
                      desc: "In my community,many coaches are now earning lakhs every month effortlessly—without wasting money on ads."
                    },
                    {
                      emoji: "🤝",
                      color: "text-purple-400",
                      title: "You're Never Alone:",
                      desc: "We'll fix that confusion—step by step,together. No more figuring it out alone."
                    }
                  ].map((item)=> (
                    <motion.li
                      key={item.title}
                      className="flex items-start gap-3"
                      variants={itemVariants}
                    >
                      <span className={`${item.color} text-xl mt-1`}>{item.emoji}</span>
                      <div className="flex-1">
                        <span className="font-medium">{item.title}</span>
                        <div className="text-gray-300 mt-1">{item.desc}</div>
                      </div>
                    </motion.li>
                  ))}
                </motion.ul>
              </div>
            </motion.div>
          </div>
        </section>

        {/* --- TESTIMONIALS SECTION --- */}
        <motion.section
          className="testimonials-section"
          initial="initial"
          whileInView="whileInView"
          transition={sectionFadeIn.transition}
          viewport={sectionFadeIn.viewport}
        >
          <div className="container">
            <motion.div className="section-content">
              <motion.h2 {...sectionFadeIn}>
                🎬 Success Stories - Video Testimonials
              </motion.h2>
              
              <motion.p 
                className="testimonials-subtitle" 
                {...sectionFadeIn} 
                transition={{delay: 0.1,...sectionFadeIn.transition}}
              >
                Real results from real Tamil entrepreneurs who turned confusion into consistent income
              </motion.p>

              <motion.div
                className="video-grid"
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{once: true,amount: 0.2}}
              >
                {testimonialVideos.map((video)=> (
                  <motion.div
                    key={video.id}
                    className="video-card"
                    onClick={()=> {
                      setSelectedVideo(video);
                      if (typeof fbq !=='undefined') {
                        fbq('track','ViewContent',{
                          content_name: video.title,
                          content_type: 'video'
                        });
                      }
                    }}
                    variants={itemVariants}
                    whileHover={{scale: 1.02,y: -8}}
                    whileTap={{scale: 0.98}}
                    tabIndex={0}
                    role="button"
                    aria-label={`Play testimonial video from ${video.name}`}
                    onKeyDown={(e)=> {
                      if (e.key==='Enter' || e.key===' ') {
                        e.preventDefault();
                        setSelectedVideo(video);
                      }
                    }}
                  >
                    <div className="video-thumbnail">
                      <img
                        src={video.thumbnail}
                        alt={`${video.title} thumbnail`}
                        loading="lazy"
                        width="300"
                        height="200"
                      />
                      <div className="play-overlay">
                        <FiPlay className="play-icon" />
                      </div>
                    </div>
                    <div className="video-info">
                      <h4>{video.title}</h4>
                      <p>{video.name}</p>
                    </div>
                  </motion.div>
                ))}
              </motion.div>
            </motion.div>
          </div>
        </motion.section>

        {/* --- CLIENT FEEDBACK SECTION --- */}
        <motion.section
          className="client-feedback-section"
          initial="initial"
          whileInView="whileInView"
          transition={sectionFadeIn.transition}
          viewport={sectionFadeIn.viewport}
        >
          <div className="container">
            <motion.div className="section-content">
              <motion.h2 {...sectionFadeIn}>
                What Our Community Members Say
              </motion.h2>
              
              <motion.p 
                className="feedback-subtitle" 
                {...sectionFadeIn} 
                transition={{delay: 0.1,...sectionFadeIn.transition}}
              >
                Real success stories from Tamil entrepreneurs who stopped wasting money and started earning consistently
              </motion.p>

              <motion.div 
                className="feedback-filter" 
                {...sectionFadeIn} 
                transition={{delay: 0.2,...sectionFadeIn.transition}}
              >
                <FiFilter className="filter-icon" />
                <select
                  value={selectedRoleFilter}
                  onChange={(e)=> setSelectedRoleFilter(e.target.value)}
                  className="role-filter-select"
                  aria-label="Filter by role"
                >
                  {uniqueRoles.map(role=> (
                    <option key={role} value={role}>
                      {role==='all' ? 'All Roles' : role}
                    </option>
                  ))}
                </select>
              </motion.div>

              <motion.div
                className="feedback-grid"
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{once: true,amount: 0.2}}
              >
                {filteredFeedbacks.map((feedback)=> (
                  <motion.div
                    key={feedback.id}
                    className="feedback-card"
                    variants={itemVariants}
                    whileHover={{scale: 1.02,y: -8}}
                    whileTap={{scale: 0.98}}
                    tabIndex={0}
                    role="article"
                    aria-labelledby={`feedback-name-${feedback.id}`}
                    onKeyDown={(e)=> {
                      if (e.key==='Enter' || e.key===' ') {
                        e.preventDefault();
                        toggleFeedbackExpanded(feedback.id);
                      }
                    }}
                  >
                    <div className="feedback-image-container">
                      {feedback.image ? (
                        <img
                          src={feedback.image}
                          alt={`${feedback.name} - ${feedback.role}`}
                          loading="lazy"
                          width="300"
                          height="200"
                          className="feedback-rect-image"
                          onError={(e)=> {
                            e.target.style.display='none';
                            e.target.nextSibling.style.display='flex';
                          }}
                        />
                      ) : null}
                      <div className="avatar-fallback-rect">
                        {getInitials(feedback.name)}
                      </div>
                    </div>

                    <div className="feedback-info">
                      <h3 id={`feedback-name-${feedback.id}`}>{feedback.name}</h3>
                      <p className="feedback-role">{feedback.role}</p>
                    </div>

                    <div className="feedback-quote">
                      <p>
                        {expandedFeedback[feedback.id] || feedback.quote.length <=140
                          ? feedback.quote
                          : `${feedback.quote.slice(0,140)}...`}
                      </p>
                      {feedback.quote.length > 140 && (
                        <button
                          className="read-more-btn"
                          onClick={()=> toggleFeedbackExpanded(feedback.id)}
                          aria-expanded={!!expandedFeedback[feedback.id]}
                          aria-controls={`feedback-quote-${feedback.id}`}
                        >
                          {expandedFeedback[feedback.id] ? 'Read less' : 'Read more'}
                        </button>
                      )}
                    </div>
                  </motion.div>
                ))}
              </motion.div>
            </motion.div>
          </div>
        </motion.section>

        {/* --- BONUS SECTION --- */}
        <motion.section
          className="bonus-section"
          initial="initial"
          whileInView="whileInView"
          transition={sectionFadeIn.transition}
          viewport={sectionFadeIn.viewport}
        >
          <div className="container">
            <motion.div className="section-content">
              <motion.h2 {...sectionFadeIn}>
                🎁 Exclusive Bonus Vault (Worth ₹25,000)
              </motion.h2>

              <motion.div
                className="bonus-grid"
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{once: true,amount: 0.2}}
              >
                {[
                  {
                    img: "https://storage.files-vault.com/uploads/1760966854-BXbDBFXvqB.png",
                    emoji: "🤖",
                    title: "AI Tools Starter Pack",
                    desc: "50+ verified AI tools list with English tutorials (Worth ₹5,000)"
                  },
                  {
                    img: "https://storage.files-vault.com/uploads/1760966871-XKw3XTHpgg.png",
                    emoji: "📊",
                    title: "Business Automation Templates",
                    desc: "Ready-to-use automation workflows for businesses (Worth ₹8,000)"
                  },
                  {
                    img: "https://storage.files-vault.com/uploads/1760976790-fakmsXQpOV.png",
                    emoji: "💬",
                    title: "Private AI Community",
                    desc: "Lifetime access to exclusive entrepreneurs AI group (Worth ₹7,000)"
                  },
                  {
                    img: "https://storage.files-vault.com/uploads/1760977051-dmxHkhczed.png",
                    emoji: "📞",
                    title: "1-on-1 AI Strategy Call",
                    desc: "Personal 30-minute session to customize AI for your business (Worth ₹5,000)"
                  }
                ].map((bonus)=> (
                  <motion.div
                    key={bonus.title}
                    className="bonus-item"
                    variants={itemVariants}
                    whileHover={{y: -8,scale: 1.02}}
                  >
                    <img
                      src={bonus.img}
                      alt={bonus.title}
                      className="bonus-image"
                      width="120"
                      height="160"
                      loading="lazy"
                    />
                    <h3>{bonus.emoji} {bonus.title}</h3>
                    <p>{bonus.desc}</p>
                  </motion.div>
                ))}
              </motion.div>
            </motion.div>
          </div>
        </motion.section>

        {/* --- FAQ SECTION --- */}
        <motion.section
          className="faq-section"
          initial="initial"
          whileInView="whileInView"
          transition={sectionFadeIn.transition}
          viewport={sectionFadeIn.viewport}
        >
          <div className="container">
            <motion.div className="section-content">
              <motion.h2 {...sectionFadeIn}>
                Frequently Asked Questions
              </motion.h2>
              
              <motion.p 
                className="faq-subtitle" 
                {...sectionFadeIn} 
                transition={{delay: 0.1,...sectionFadeIn.transition}}
              >
                Got questions? We've got answers. Find everything you need to know about our program.
              </motion.p>

              <motion.div 
                className="faq-search" 
                {...sectionFadeIn} 
                transition={{delay: 0.2,...sectionFadeIn.transition}}
              >
                <FiSearch className="search-icon" />
                <input
                  type="text"
                  placeholder="Search questions..."
                  value={faqSearch}
                  onChange={(e)=> handleFaqSearch(e.target.value)}
                  className="search-input"
                  aria-label="Search frequently asked questions"
                />
              </motion.div>

              <div className="faq-accordion">
                {filteredFaqs.map((faq)=> (
                  <motion.div key={faq.id} className="faq-item" layout>
                    <button
                      className="faq-question"
                      onClick={()=> toggleFaq(faq.id)}
                      aria-expanded={expandedFaq===faq.id}
                      aria-controls={`faq-answer-${faq.id}`}
                      id={`faq-question-${faq.id}`}
                    >
                      <span>{faq.question}</span>
                      <FiChevronDown 
                        className={`chevron-icon ${expandedFaq===faq.id ? 'expanded' : ''}`} 
                      />
                    </button>
                    <AnimatePresence>
                      {expandedFaq===faq.id && (
                        <motion.div
                          id={`faq-answer-${faq.id}`}
                          className="faq-answer"
                          role="region"
                          aria-labelledby={`faq-question-${faq.id}`}
                          initial={{height: 0,opacity: 0}}
                          animate={{height: 'auto',opacity: 1}}
                          exit={{height: 0,opacity: 0}}
                          transition={{duration: 0.3,ease: "easeInOut"}}
                        >
                          <div className="faq-answer-content">{faq.answer}</div>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </motion.div>
                ))}
              </div>

              {filteredFaqs.length===0 && (
                <motion.div
                  className="faq-no-results"
                  initial={{opacity: 0}}
                  animate={{opacity: 1}}
                  transition={{duration: 0.3}}
                >
                  <p>No questions found matching your search. Try different keywords.</p>
                </motion.div>
              )}
            </motion.div>
          </div>
        </motion.section>

        {/* --- Section 6: Final CTA --- */}
        <motion.section
          className="final-cta"
          initial="initial"
          whileInView="whileInView"
          transition={sectionFadeIn.transition}
          viewport={sectionFadeIn.viewport}
        >
          <div className="container">
            <motion.div className="cta-content">
              <motion.h2 {...sectionFadeIn}>
                🔥 Admin Work-ல் Time Waste பண்ணாதீங்க. உங்க Sales Process-ஐ Automate பண்ணுங்க!
              </motion.h2>
              
              <motion.p 
                className="cta-subtitle" 
                {...sectionFadeIn} 
                transition={{delay: 0.1,...sectionFadeIn.transition}}
              >
                Regular Price: ₹2,997 | Today Only: ₹9 (99% Discount) - Only 50 Seats Available!
              </motion.p>

              <WorkshopTimer className="large" />

              <motion.button
                className="cta-primary large"
                onClick={()=> {
                  handleManualModalOpen();
                  if (typeof fbq !=='undefined') {
                    fbq('track','InitiateCheckout',{
                      content_name: 'Sales Automation Workshop - Final CTA',
                      content_category: 'Workshop',
                      value: 9,
                      currency: 'INR'
                    });
                  }
                }}
                {...sectionFadeIn}
                transition={{delay: 0.4,...sectionFadeIn.transition}}
                whileHover={{scale: 1.05,y: -4}}
                whileTap={{scale: 0.95}}
              >
                Register Now For Just ₹9 🚀
              </motion.button>

              <motion.div 
                className="guarantee-text" 
                {...sectionFadeIn} 
                transition={{delay: 0.5,...sectionFadeIn.transition}}
              >
                <FiCheck className="check-icon" />
                <span>100% Money Back Guarantee - No Questions Asked</span>
              </motion.div>
            </motion.div>
          </div>
        </motion.section>

        {/* --- POP-UP MODAL --- */}
        <AnimatePresence>
          {isFormModalOpen && (
            <motion.div
              className="modal-overlay"
              initial={{opacity: 0}}
              animate={{opacity: 1}}
              exit={{opacity: 0}}
              onClick={(e)=> {
                if (e.target===e.currentTarget) setIsFormModalOpen(false);
              }}
            >
              <motion.div
                className="modal-content"
                id="registration-modal"
                initial={{opacity: 0,scale: 0.8,y: 20}}
                animate={{opacity: 1,scale: 1,y: 0}}
                exit={{opacity: 0,scale: 0.8,y: 20}}
                transition={{type: "spring",stiffness: 300,damping: 25}}
                ref={modalRef}
              >
                <div className="modal-header">
                  <h3>🚀 3-Hour Sales Automation Workshop-க்கு Register பண்ணுங்க!</h3>
                  <button
                    className="close-button"
                    onClick={()=> setIsFormModalOpen(false)}
                    aria-label="Close registration form"
                  >
                    <FiX />
                  </button>
                </div>

                <form onSubmit={handleSubmit} className="registration-form">
                  <div className="form-group">
                    <label htmlFor="name">
                      <FiUser className="input-icon" /> Full Name *
                    </label>
                    <input
                      ref={firstInputRef}
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={(e)=> handleInputChange('name',e.target.value)}
                      placeholder="Enter your full name"
                      className={formErrors.name ? 'error' : ''}
                      aria-describedby={formErrors.name ? 'name-error' : undefined}
                    />
                    {formErrors.name && (
                      <span id="name-error" className="error-message" role="alert">
                        {formErrors.name}
                      </span>
                    )}
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">
                      <FiMail className="input-icon" /> Email Address *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={(e)=> handleInputChange('email',e.target.value)}
                      placeholder="Enter your email address"
                      className={formErrors.email ? 'error' : ''}
                      aria-describedby={formErrors.email ? 'email-error' : undefined}
                    />
                    {formErrors.email && (
                      <span id="email-error" className="error-message" role="alert">
                        {formErrors.email}
                      </span>
                    )}
                  </div>

                  <div className="form-group">
                    <label htmlFor="phone">
                      <FiPhone className="input-icon" /> Phone Number *
                    </label>
                    <div className="phone-input-group">
                      <select
                        value={formData.countryCode}
                        onChange={(e)=> handleInputChange('countryCode',e.target.value)}
                        className="country-select"
                        aria-label="Country code"
                      >
                        {countryCodes.map((country)=> (
                          <option key={country.code} value={country.code}>
                            {country.flag} {country.code}
                          </option>
                        ))}
                      </select>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={(e)=> handleInputChange('phone',e.target.value.replace(/\D/g,''))}
                        placeholder="9884899080"
                        className={formErrors.phone ? 'error' : ''}
                        aria-describedby={formErrors.phone ? 'phone-error' : undefined}
                        maxLength="10"
                      />
                    </div>
                    {formErrors.phone && (
                      <span id="phone-error" className="error-message" role="alert">
                        {formErrors.phone}
                      </span>
                    )}
                  </div>

                  <div className="form-group">
                    <label htmlFor="profession">
                      <FiBriefcase className="input-icon" /> Profession/Role *
                    </label>
                    <select
                      id="profession"
                      name="profession"
                      value={formData.profession}
                      onChange={(e)=> handleInputChange('profession',e.target.value)}
                      className={formErrors.profession ? 'error' : ''}
                      aria-describedby={formErrors.profession ? 'profession-error' : undefined}
                    >
                      <option value="">Select your profession</option>
                      <option value="Business Owner">Business Owner</option>
                      <option value="Entrepreneur">Entrepreneur</option>
                      <option value="Freelancer">Freelancer</option>
                      <option value="Sales Professional">Sales Professional</option>
                      <option value="Coach / Consultant">Coach / Consultant</option>
                      <option value="Marketer">Marketer</option>
                      <option value="Student">Student</option>
                      <option value="Other">Other</option>
                    </select>
                    {formErrors.profession && (
                      <span id="profession-error" className="error-message" role="alert">
                        {formErrors.profession}
                      </span>
                    )}
                  </div>

                  <div className="form-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        checked={formData.consent}
                        onChange={(e)=> handleInputChange('consent',e.target.checked)}
                        className={formErrors.consent ? 'error' : ''}
                        aria-describedby={formErrors.consent ? 'consent-error' : undefined}
                      />
                      <span className="checkmark"></span>
                      I agree to receive updates about the program and understand the terms & conditions *
                    </label>
                    {formErrors.consent && (
                      <span id="consent-error" className="error-message" role="alert">
                        {formErrors.consent}
                      </span>
                    )}
                  </div>

                  <button
                    type="submit"
                    className="submit-button"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Processing...' : 'Register Now & Pay ₹9 🚀'}
                  </button>

                  <p className="form-note">
                    After registration,you'll be redirected to secure payment page. <br />
                    <strong>100% Money Back Guarantee</strong>
                  </p>
                </form>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>

        {/* --- VIDEO MODAL --- */}
        <AnimatePresence>
          {selectedVideo && (
            <motion.div
              className="video-modal-overlay"
              initial={{opacity: 0}}
              animate={{opacity: 1}}
              exit={{opacity: 0}}
              onClick={(e)=> {
                if (e.target===e.currentTarget) setSelectedVideo(null);
              }}
            >
              <motion.div
                className="video-modal-content"
                initial={{opacity: 0,scale: 0.8}}
                animate={{opacity: 1,scale: 1}}
                exit={{opacity: 0,scale: 0.8}}
                transition={{type: "spring",stiffness: 300,damping: 25}}
              >
                <div className="video-modal-header">
                  <h3>{selectedVideo.title}</h3>
                  <button
                    className="close-button"
                    onClick={()=> setSelectedVideo(null)}
                    aria-label="Close video"
                  >
                    <FiX />
                  </button>
                </div>
                <div className="video-embed-container">
                  <iframe
                    src={`https://www.youtube.com/embed/${selectedVideo.embedId}?autoplay=1&rel=0`}
                    title={selectedVideo.title}
                    allow="accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture"
                    allowFullScreen
                    loading="lazy"
                  ></iframe>
                </div>
                <div className="video-fallback">
                  <p>
                    Can't view the video?{' '}
                    <a href={selectedVideo.url} target="_blank" rel="noopener noreferrer">
                      Open on YouTube
                    </a>
                  </p>
                </div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>

        {/* --- Sticky Footer --- */}
        <motion.div
          className="sticky-footer"
          initial={{y: "100%"}}
          animate={{y: "0%"}}
          transition={{duration: 0.7,ease: "easeInOut",delay: 1.5}}
        >
          <motion.div
            className="footer-info-box"
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            transition={{duration: 0.5,delay: 2.2}}
          >
            <div className="date">Next Workshop:</div>
            <div className="time">{workshopDetails.formattedDate} @ {workshopDetails.timeString}</div>
          </motion.div>

          <motion.button
            className="footer-cta-button"
            onClick={()=> {
              handleManualModalOpen();
              if (typeof fbq !=='undefined') {
                fbq('track','InitiateCheckout',{
                  content_name: 'Sales Automation Workshop - Sticky Footer CTA',
                  content_category: 'Workshop',
                  value: 9,
                  currency: 'INR'
                });
              }
            }}
            whileHover={{scale: 1.05}}
            whileTap={{scale: 0.95}}
            animate={{
              scale: [1,1.03,1],
              transition: {duration: 1.5,repeat: Infinity,ease: "easeInOut",delay: 2.5}
            }}
          >
            Register Now (₹9) 🚀
          </motion.button>
        </motion.div>

        <footer className="footer">
          <div className="container">
            <div className="footer-content">
              <p>&copy;2025 10xAI Founder. All rights reserved.</p>
              <p style={{fontSize: '0.8rem',opacity: '0.7',marginTop: '1rem'}}>
                This site is not part of the Facebook website or Facebook Inc. Additionally,this site is NOT endorsed by. FACEBOOK is a trademark of FACEBOOK,Inc.
              </p>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}

export default App;